import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { convertStringToBoolean, getPref, PreferData, setUpdatePref } from '@core/_utils/tools.utils';
import { CommonService } from '@service/common.service';
import { AuthService } from '@auth/auth.service';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
    public isAdmin = false;
    public dashItem: any = {};

    public dragCurrent: any;
    public dashConfTable: any[];
    public dashParamNewTable: any[];

    @ViewChild('overpanel') public overpanel;
    constructor(
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private auth: AuthService,
        private commonService: CommonService,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.isAdmin = this.auth.isAdmin();
    }
    
    ngOnInit() {
        this.commonService.checkReset();
        this.dashConfTable = new Array();
        this.dashParamNewTable = new Array();
        this.execPref();
    }

    private async execPref() {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getuserpreference', ''));
            this.dashItem.statNbDoc = convertStringToBoolean(getPref(wRes.data, 6, 'false').datapref);
            this.dashItem.statOldDoc = convertStringToBoolean(getPref(wRes.data, 29, 'true').datapref);
            this.dashItem.lastReq = convertStringToBoolean(getPref(wRes.data, 30, 'true').datapref);                
            this.dashItem.statLoad = convertStringToBoolean(getPref(wRes.data, 31, 'true').datapref);
            this.dashItem.statView = convertStringToBoolean(getPref(wRes.data, 32, 'true').datapref);
            this.dashItem.statWork = convertStringToBoolean(getPref(wRes.data, 33, 'true').datapref);        
            this.setParam(wRes);
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Failed_GetUsrPref'));
        }
    }

    public ngOnDestroy() {}

    private setValue(aParam) {
        let wObj: any;
        wObj = new Object();
        wObj.value = aParam;
        wObj.label = this.getLabel(aParam);
        return wObj;
    }

    private setParam(aRes) {
        let wPrefData: PreferData;
        wPrefData = getPref(aRes.data, 10, 'int');
        this.setParamTable(wPrefData, 10, 'int');

        wPrefData = getPref(aRes.data, 11, 'wrk');
        this.setParamTable(wPrefData, 11, 'wrk');

        wPrefData = getPref(aRes.data, 12, 'view');
        this.setParamTable(wPrefData, 12, 'view');

        wPrefData = getPref(aRes.data, 13, 'load');
        this.setParamTable(wPrefData, 13, 'load');

        wPrefData = getPref(aRes.data, 14, 'old');
        this.setParamTable(wPrefData, 14, 'old');

        wPrefData = getPref(aRes.data, 15, 'em1');
        this.setParamTable(wPrefData, 15, 'em1');

        wPrefData = getPref(aRes.data, 16, 'em2');
        this.setParamTable(wPrefData, 16, 'em2');

        wPrefData = getPref(aRes.data, 17, 'em3');
        this.setParamTable(wPrefData, 17, 'em3');

        wPrefData = getPref(aRes.data, 18, 'em4');
        this.setParamTable(wPrefData, 18, 'em4');

        wPrefData = getPref(aRes.data, 19, 'em5');
        this.setParamTable(wPrefData, 19, 'em5');  
    }

    private setParamTable(aParam, aId, aAction) {
        let wAction = '';
        if (aParam.id === 0) {
            wAction = aAction
        } else {
            wAction = aParam.datapref
        }
        this.dashConfTable.push({param: aParam, id: aId, action: wAction});
        this.dashParamNewTable.push({datapref: this.setValue(wAction), action: wAction});
    }

    private getLabel(aValue) {
        let wLabel = '';
        if (aValue === 'int') {
            if (this.isAdmin === true) {
                wLabel = this.translate.instant('Doc_Dash_1');
            }
        }
        if (aValue === 'wrk') {
            if (this.dashItem.statWork === true) {
                wLabel = this.translate.instant('Doc_Dash_2');
            }
        }
        if (aValue === 'view') {
            if (this.dashItem.statView === true) {
                wLabel = this.translate.instant('Doc_Dash_3');
            }
        }
        if (aValue === 'load') {
            if (this.dashItem.statLoad === true) {
                wLabel = this.translate.instant('Doc_Dash_4');
            }
        }
        if (aValue === 'old') {
            if (this.dashItem.statOldDoc === true) {
                wLabel = this.translate.instant('Doc_Dash_5');
            }
        }
        if (aValue === 'em1') {
            if (this.dashItem.lastReq === true) {
                wLabel =  this.translate.instant('Doc_Dash_6');
            }
        }
        return wLabel;
    }

    public onClickEnter() {
        this.overpanel.hide();
        this.execUpdate();
    }   

    private async execUpdate() {
        let wRes: any = {};
        let wRequestList = [];
        let wRequestData: {};        
        for (let index = 0; index < this.dashConfTable.length; index++) {
            const item = this.dashConfTable[index];
            const itemNew = this.dashParamNewTable[index];
            wRequestData = {
                requestData: setUpdatePref( item.param.id, item.id, itemNew.action)
            };
            wRequestList.push(wRequestData);                        
        }
        wRequestData = {
            updatelist: wRequestList,
        };
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('updatepreference', wRequestData));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            return;
        }
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getuserpreference', ''));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        this.dashConfTable = [];
        this.dashParamNewTable = [];
        this.setParam(wRes);
    }

    public dragStart(event,aIndex: any) {
        this.dragCurrent = this.dashParamNewTable[aIndex];
        this.dragCurrent.index = aIndex;
    }
    
    public dragEnd(event) {
        this.dragCurrent = null;
    }

    public drop(event, aParam, aIndex) {
        if(this.dragCurrent) {
            this.dashParamNewTable[aIndex].datapref = this.setDrop(this.dragCurrent, this.dashParamNewTable[aIndex], aIndex);
        }
    }

    private setDrop(aDragCurrent, aObj, aIndex) {
        let wObj: any;
        wObj = { label: aDragCurrent.datapref.label, value: aDragCurrent.datapref.value };
        this.dashParamNewTable[aIndex].datapref = { label: aObj.datapref.label, value: aObj.datapref.value };
        this.dashParamNewTable[aIndex].action = aDragCurrent.action;
        this.dashParamNewTable[aDragCurrent.index].datapref = { label: aObj.datapref.label, value: aObj.datapref.value };
        this.dashParamNewTable[aDragCurrent.index].action = aObj.datapref.value;
        this.dragCurrent = null;
        return wObj;
    }
}
